import type { BreadcrumbItem } from '@graftcode/design-system'
import { Icon } from '@graftcode/design-system'

import { SECTION_URL_MAP } from '../academy-header-nav.const'

export function buildNavbarBreadcrumbItems(segments: string[]): BreadcrumbItem[] {
  const homeItem: BreadcrumbItem = {
    text: '',
    icon: Icon.HomeFilled,
    url: '/',
  }

  return [
    homeItem,
    ...segments.map((segment, index) => {
      const item: BreadcrumbItem = {
        text: segment,
        active: index === segments.length - 1,
      }

      if (index === 0 && segment in SECTION_URL_MAP) {
        item.url = SECTION_URL_MAP[segment]
      }

      return item
    }),
  ]
}
